import clsx from 'clsx'
import React, { FC, useContext, useEffect, useState } from 'react'

import { Button } from '@CoreComponents/Buttons/Button'
import { AdyenContext2 } from '@Domains/Checkout/Providers/AdyenContextProvider'
import { buildAdyenComponent } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyen'
import {
  useAdyenCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Adyen/Hooks/useAdyenCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'
import { Spinner } from '@Shared/Components/Spinner/Spinner'

import styles from './AdyenRedirect.module.scss'

export const AdyenRedirectButton: FC<CheckoutPaymentComponentProps> = ({
  option,
  submitPayment,
  submitWithoutData,
}) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()
  const {
    adyenConfig,
    adyenInstance,
  } = useContext(AdyenContext2)
  const {
    handleAdyenResponse,
    submitAdyenAdditionalDetails,
  } = useAdyenCheckoutResponse()
  const [adyenComponent, setAdyenComponent] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (adyenComponent) {
      return
    }
    const component = buildAdyenComponent(adyenInstance, option.type, undefined, adyenConfig, {
      onSubmit: undefined,
      onAdditionalDetails: (state) => {
        submitAdyenAdditionalDetails(state.data)
      },
    })
    setAdyenComponent(component)
    setLoading(false)
  }, [adyenComponent, adyenConfig, adyenInstance, option.type, submitAdyenAdditionalDetails])

  return (
    <div key={option.id} className={styles.adyenRedirectButtonWrapper}>
      {loading && <Spinner className={clsx(styles.adyenRedirectSpinner, styles.loading)} />}
      {!loading && (
        <Button
          className={clsx(styles.adyenRedirect, !cofDesignV1 && styles.adyenRedirectButton)}
          innerSpacing="medium"
          onClick={() => {
            if (adyenComponent) {
              submitPayment(
                submitWithoutData
                  ? null
                  : (adyenComponent as any)?.data,
                response => handleAdyenResponse(adyenInstance, response),
              )
            }
          }}
          type="button"
        >
          {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
        </Button>
      )}
    </div>
  )
}
